export default __webpack_public_path__ + "static/media/11.87adbe1b.jpg";